// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_logo__7QJj8","logoImage":"logo_logoImage__lvBaq"};